export default __webpack_public_path__ + "static/media/298.8df49701.gif";